import { createUpsell } from '../upsell';
export const Ajk2S0 = createUpsell({
    id: 'Ajk2S0',
    desc: 'Upsell sequence fitness - AU',
    seq: [
        'upsell-12-month',
        'upsell-yoga-healthy-back',
        'upsell-fast-food',
        'upsell-detox',
        'upsell-alcohol',
        'upsell-sweet-treats',
    ],
});
